import { Alert } from '@mui/material';

import AuthContext from 'contexts/JWTAuth';
import { useContext } from 'react';

const AlertInfo = ({ status }) => {
    const { user } = useContext(AuthContext);
    return (
        <>
            {status === 'submitted' && user?.role === 'group' && (
                <Alert severity={'info'} sx={{ width: '100%', mb: 2 }}>
                    The registration has been submitted, please wait for the
                    admin <strong>Approval</strong> to generate the invoice.
                </Alert>
            )}

            {status === 'gl_uploaded' && user?.role === 'group' && (
                <Alert severity={'info'} sx={{ width: '100%', mb: 2 }}>
                    Your guarantee letter has been uploaded, please wait for the
                    admin <strong>Approval</strong> to get the{' '}
                    <strong>Participant Invoice</strong>.
                </Alert>
            )}
        </>
    );
};

export default AlertInfo;
